<template>
    <v-chip
        v-if="isVisible"
        border="primary-light opacity-100"
        size="large"
        color="primary"
        class="w-100 rounded border-s-md border-e-sm border-t-sm border-b-sm bg-focused mb-2"
    >
        <svg-icon class="m-0" :icon="check" alt="info" />
        <p data-id="notificationMessage" class="font-weight-regular text-secondary-light ml-2 text-size-xs text-pre-wrap">{{ message }}</p>
    </v-chip>
</template>

<script setup lang="ts">
import check from '@/assets/check.svg';
import SvgIcon from '@/features/common/components/SvgIcon.vue';
export interface INotificationCard {
    isVisible?: boolean;
    message: string;
}

withDefaults(defineProps<INotificationCard>(), {
    isVisible: true
});
</script>
